function TextSlider(el) {
    new Flickity(el, {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        autoPlay: 5000,
        adaptiveHeight: false,
        cellAlign: 'left'
    });
}

(function() {
    const textSliderEls = document.querySelectorAll('.jsTextSlider');
    [...textSliderEls].map(el => new TextSlider(el));
})();
